export default "__VITE_ASSET__a8a43bb9__"